export default __webpack_public_path__ + "static/char-s-21-en-940aabf60146841798ddd78df2650a1e.webp";